module.exports = __webpack_public_path__ + "img/btc.c5dd60e8.png";